import { BaseApiService } from "../../base/base-api.service";
import { PositionDTO } from "../../../models/recruiting/positions/position-dto";
import { PositionSTO } from "../../../models/recruiting/positions/position-sto";
import { toastifyResponse } from "../../../utils/toastify-response/toastify-response";

export class PositionsApiService extends BaseApiService<PositionDTO, PositionSTO> {
  constructor() {
    super({
      servicePath: "/Positions",
      loadItemsPath: "/GetPositions",
      saveItemsPath: "/SavePositions",
    });
  }
}

export const savePosition = async (position: PositionSTO) => {
  const response = await new PositionsApiService().saveItems([position]);

  toastifyResponse(response);

  return response;
};
